import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Utils } from 'core/utils';
import { TextAlignment } from '../../text/text.model';

@Component({
    selector: 'text-alignment-chooser',
    templateUrl: './text-alignment-chooser.component.html',
    styleUrls: ['./text-alignment-chooser.component.scss'],
    standalone: false
})
export class TextAlignmentChooserComponent
{
  @Input('alignment') public alignment: TextAlignment;
  @Output() public alignmentChange: EventEmitter<TextAlignment> =
    new EventEmitter();

  public readonly textAlignment: any = TextAlignment;
  public alignLeftUrl: string = Utils.url(
      './assets/img/text-editor/align-left.svg');
  public alignMiddleUrl: string = Utils.url(
      './assets/img/text-editor/align-center.svg');
  public alignRightUrl: string = Utils.url(
      './assets/img/text-editor/align-right.svg');

  public setAlignment(newAlignment: TextAlignment): void
  {
    this.alignment = newAlignment;
    this.alignmentChange.emit(newAlignment);
  }
}
